@if ({ privacyList: privacyList$ | async, selectedPrivacy: selectedPrivacy$ | async }; as data) {
    <div class="privacy">
        <div class="privacy__options" role="radiogroup">
            @for (privacy of data.privacyList; track privacy.value) {
                <label class="option"
                       [class.option--selected]="data.selectedPrivacy == privacy.value"
                       [class.option--danger]="data.selectedPrivacy == privacyEnum.Hidden && privacy.value == privacyEnum.Hidden">
                    <input type="radio"
                           class="option__input"
                           name="jobseeker-privacy"
                           [value]="privacy.value"
                           [checked]="data.selectedPrivacy == privacy.value"
                           (change)="onChangeJobseekerPrivacy(privacy.value)">
                    <span class="option__radio" aria-hidden="true"></span>
                    <span class="option__body">
                        <span class="option__label">{{ privacyMap[privacy.value].label | translate }}</span>
                        <span class="option__text">{{ privacyMap[privacy.value].text | translate }}</span>
                    </span>
                </label>
            }
        </div>

        <div class="privacy__buttons">
            <button type="button" class="privacy__save" (click)="onSave(data.selectedPrivacy)">{{ 'label.Save' | translate }}</button>
            <button type="button" class="privacy__cancel" (click)="onCancel()">{{ 'label.Cancel' | translate }}</button>
        </div>
    </div>
}
